window.Rocketify = window.Rocketify || {}

window.Rocketify.parseAttribute = (raw) => {
  if (!raw) {
    return []
  }
  return raw.split(';;').map((variant) => {
    const [variantId, value] = variant.split('::')

    return {
      variantId: parseInt(variantId, 10),
      value,
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const backinstockCollectionListener = (product) => () => {
    const modal = document.getElementById('backinstock-modal')
    modal.dispatchEvent(new CustomEvent('open', { detail: { product } }))
  }

  const backinstockProductListener =
    ({ product, variant }) =>
    () => {
      const modal = document.getElementById('backinstock-modal')
      modal.dispatchEvent(
        new CustomEvent('open', { detail: { product, variant } })
      )
    }

  const setupProductBackinstock = () => {
    const { parseAttribute } = window.Rocketify
    const productForm = document.querySelector('product-form')

    const backinstockVariants = parseAttribute(
      productForm?.getAttribute('data-all-backinstock-variante')
    ).map(({ variantId, value }) => ({
      variantId,
      value: value === 'true',
    }))
    const productBackinstock = document.querySelectorAll('.product-backinstock')
    const buttonsContainer = document.querySelector('.quantity-submit-row')

    for (const btn of productBackinstock) {
      const variantPicker = document.querySelector('variant-picker')
      const product = JSON.parse(btn.getAttribute('data-product'))
      const variant =
        variantPicker.getSelectedVariant && variantPicker.getSelectedVariant()

      btn.removeEventListener(
        'click',
        backinstockProductListener({ product, variant })
      )
      const addToCart = document.querySelector('.add-to-cart')
      const outOfStock = buttonsContainer.querySelector(
        'button[name="add"][type="submit"]'
      )
      const quantityWrapper = document.querySelector('quantity-wrapper')
      const quantitySelectors = quantityWrapper?.querySelectorAll('a') || []
      const quantityInput = quantityWrapper?.querySelector('input')
      const paypalCta = document.querySelector('shopify-accelerated-checkout')

      if (!variant?.available) {
        addToCart.classList.add('hidden')
        if (
          backinstockVariants.find((row) => row.variantId === variant?.id)
            ?.value
        ) {
          outOfStock.classList.add('hidden')
          btn.classList.remove('hidden')
          btn.addEventListener(
            'click',
            backinstockProductListener({ product, variant })
          )
        } else {
          outOfStock.classList.remove('hidden')
          btn.classList.add('hidden')
        }
        for (const link of quantitySelectors) {
          link.style.pointerEvents = 'none'
        }
        if (quantityInput) {
          quantityInput.style.pointerEvents = 'none'
        }
        if (paypalCta) {
          paypalCta.style.display = 'none'
        }
      } else {
        addToCart.classList.remove('hidden')
        outOfStock.classList.remove('hidden')
        btn.classList.add('hidden')
        for (const link of quantitySelectors) {
          link.style.pointerEvents = 'auto'
        }
        if (quantityInput) {
          quantityInput.style.pointerEvents = 'auto'
        }
        if (paypalCta) {
          paypalCta.style.display = 'block'
        }
      }
    }
  }

  const intervalFn = () => {
    const backinstockCollection = document.querySelectorAll(
      '.collection-backinstock'
    )
    for (const btn of backinstockCollection) {
      const product = JSON.parse(btn.getAttribute('data-product'))

      btn.removeEventListener('click', backinstockCollectionListener(product))
      btn.addEventListener('click', backinstockCollectionListener(product))
    }

    setupProductBackinstock()
  }

  let interval = setInterval(intervalFn, 1000)

  document.addEventListener('on:variant:change', (e) => {
    clearInterval(interval)
    setupProductBackinstock()
    interval = setInterval(intervalFn, 1000)
  })

  setupProductBackinstock()
})
